"use strict";
// This file contains interface versions of browser types that can be serialized to Plain Old
// JavaScript Objects
var LocationType = (function () {
    function LocationType(href, protocol, host, hostname, port, pathname, search, hash, origin) {
        this.href = href;
        this.protocol = protocol;
        this.host = host;
        this.hostname = hostname;
        this.port = port;
        this.pathname = pathname;
        this.search = search;
        this.hash = hash;
        this.origin = origin;
    }
    return LocationType;
}());
exports.LocationType = LocationType;
//# sourceMappingURL=serialized_types.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@angular/platform-browser/src/web_workers/shared/serialized_types.js
 ** module id = 146
 ** module chunks = 0
 **/